import { http } from "../../../shared/api/http";
import { ChatMessage} from "../models/type";

export async function sendMessages(data:any): Promise<ChatMessage> {
  const res = await http.post(`/restaurant/chat/messages`,data);
  return res.data;
}